import { WSModel } from "apps/WebCabApp/ws";
import { WSMessage } from "apps/WebCabApp/ws/WSModel";
import { useCallback, useEffect } from "react";
import { IMessage, messageSerializer } from "./type";
import { requests } from "utils/requests";
import { useSnackbar } from "notistack";
import { Box } from "@mui/material";
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import { useHistory } from "react-router-dom";
import Sound from "apps/WebCabApp/components/sound";

export default function MessageDelivery() {
  // Хук для пометки сообщений как доставленных при их получении
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const history = useHistory();
  const { playChatReceived } = Sound();

  const onDelivered = useCallback((message_id: number) => {
    requests.patch(`/message/${message_id}/delivered/`);
  }, [])

  const onLoad = useCallback(() => {
    requests.withoutErrorMessage().get("/message/", {
      undelivered: true,
    }).then((r) => {
      const messages: IMessage[] = r.body.results.map((i: any) => messageSerializer(i));
      messages.forEach((m) => {
        if(m.role !== "Client"){
          onDelivered(m.id!)
        }
      })
    })
  }, [onDelivered])
  useEffect(onLoad, [onLoad])

  useEffect(()=>{
    const WS = (message:WSMessage) => {
      const _message = messageSerializer(message.data)
      if(_message.role !== "Client"){
        onDelivered(_message.id!);
        playChatReceived();
        const snackbarId = enqueueSnackbar(
          (
            <Box sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
            }}>
              <Box>
                <ChatOutlinedIcon
                  fontSize={"medium"}
                  sx={{
                    display: "block",
                  }}
                />
              </Box>
              <Box sx={{
                whiteSpace: "pre-wrap",
                flexShrink: 1,
                flexGrow: 1,
              }}>
                {_message.message}
              </Box>
            </Box>
          ),
          {
            variant: 'info',
            autoHideDuration: 5000,
            hideIconVariant: true,
            SnackbarProps: {
              onClick: () => {
                closeSnackbar(snackbarId);
                history.push(`/chat/${_message.order}/`);
              }
            }
          }
        )
      }
    }
    WSModel.subscribe(WS, /^webcab\.order\.message\.new/);
    return () => {
      WSModel.unsubscribe(WS);
    }
  }, [onDelivered, enqueueSnackbar, closeSnackbar, history, playChatReceived])
  
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        onLoad();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [onLoad]);

  return null;
}